import { render, staticRenderFns } from "./RecordEditor.vue?vue&type=template&id=b26a1526"
import script from "./RecordEditor.vue?vue&type=script&lang=js"
export * from "./RecordEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports